import { initialState } from '@/models/options';

/**
 * Proforma invoices got their own "Proforma Files" column. Fill in the new key
 * so a returning user sees the column instead of hydrating it as hidden.
 */
const v42 = (state: any) => ({
  ...state,
  options: {
    ...state.options,
    tableViews: {
      ...state.options?.tableViews,
      invoicesTable: {
        ...initialState.tableViews.invoicesTable,
        ...state.options?.tableViews?.invoicesTable,
      },
    },
  },
});

export default v42;
